import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
//   this.deleteChat()
  }

  ngAfterViewInit() {
      // this.deleteChat()
  }


  deleteChat() {
  //  document.getElementsByTagName('iframe')[6].style.visibility = 'hidden';
  }


}
